import React, { useState } from "react";
import { useAcceptCookies } from "../utils/useAcceptedCookies";

export default function Protect({ children }) {
  const { acceptedCookies, onAcceptCookies } = useAcceptCookies('verify')
  const [answer, setAnswer] = useState("");

  const checkPw = () => {
    if (answer === "sandiego") {
      onAcceptCookies();
    } else {
      alert("Incorrect password. Please try again.");
    }
  };

  return (
    <div className="">
      {acceptedCookies ? <>{children}</>
        : (
          <section className="bg-gray-800 text-white">
            <form onSubmit={checkPw} className="min-h-screen flex flex-col justify-center max-w-xl mx-auto">
              <div className="mb-6">
                <h1 className="h1 mb-2">This page is password protected.</h1>
                <p>Please enter the password to view the content.</p>
              </div>
              <div className="">
                <label className="sr-only" htmlFor="password">Password</label>
                <input className="block mb-4 text-black" placeholder="Password" id="password" name="password" type="password" value={answer} onChange={(e) => setAnswer(e.target.value)} />
                <button className="btn btn-primary">Submit</button>
              </div>
            </form>
          </section>
        )
      }
    </div>
  )
}